import { atom } from "recoil";
import { MakerData ,Position} from "../types/type";

export const CurrentPosition = atom<Position>({
  key: "currentPosition",
  default: {
    lat: 0,
    lng: 0,
  },
});

export const CurrentMaker = atom<MakerData | null>({
  key: "currentMarker",
  default: null,
});

export const CurrentPoint = atom<number>({
  key: "currentPoint",
  default: 0,
});

export const CurrentAmount = atom<number>({
  key: "currentAmount",
  default: 0,
});

export const CurrentEmission = atom<number>({
  key: "currentEmission",
  default: 0,
});

export const Bookmarks = atom<number[]>({
  key: "bookmarks",
  default: [],
});

export const BookmarkMarkers = atom<MakerData[]>({
  key: "bookmarkMarkers",
  default: [],
});

export const AreaMarkers = atom<MakerData[]>({
  key: "areaMarkers",
  default: [],
});

export const RelevantMarkers = atom<MakerData[]>({
  key: "relevantMarkers",
  default: [],
});

export const UaParser = atom<UAParser.IResult | null>({
  key: "uaParser",
  default: null,
});